module.exports = __webpack_public_path__ + "img/google-play.d13641c.svg";